import * as types from '../actionType';

let initState = {
  leaveRecList: [],
};

function LeaveRecState(state = initState, action) {
  switch (action.type) {
      case types.GET_ALL_LEAVEREC_SUCCESS: {
        return {
        ...state,
        leaveRecList:action.result
        }
      }
      default:
        return state;
  }
}


export default LeaveRecState;